<template>
  <div class="bg-white h-screen shadow-md w-[300px] flex flex-col">
    <figure class="mx-auto w-[150px] aspect-[5/3] mt-5">
      <img src="@/assets/images/logo.png" alt="Logo" class="w-full h-full object-contain" />
    </figure>

    <v-btn
      @click="newDocument"
      variant="flat"
      class="!py-3 !bg-primary-main/80 !m-5 !rounded-xl !tracking-normal !font-black !capitalize !text-white !h-auto"
      prepend-icon="mdi-plus-circle-outline"
    >
      New Document
    </v-btn>

    <div class="flex-1 grid gap-2 content-start">
      <router-link
        @click="setSelectedItem(link.url)"
        class="hover:!text-primary-main flex items-center !border-r-2 hover:bg-primary-light duration-200 py-3 px-7 border-transparent"
        v-for="(link, index) in dashboardSideNavLinks"
        :key="index"
        :to="link.url"
        :class="
          selectedItem === link.url
            ? 'border-primary-main !text-primary-main bg-primary-light'
            : ''
        "
      >
        <Icon :icon="link.icon" class="text-xl" />
        <span class="ml-3">{{ link.title }}</span>
      </router-link>
    </div>

    <div class="grid gap-2 content-start">
      <div
        @click="setSelectedItem('/dashboard/referral');openReferral()"
        class="cursor-pointer hover:!text-primary-main flex items-center !border-r-2 hover:bg-primary-light duration-200 py-3 px-7 border-transparent"
        :class="
          selectedItem === '/dashboard/referral'
            ? 'border-primary-main !text-primary-main bg-primary-light'
            : ''
        "
      >
        <Icon :icon="'ant-design:dollar-outlined'" class="text-xl" />
        <span class="ml-3">Referral Program</span>
      </div>
      <router-link
        @click="setSelectedItem('/dashboard/support')"
        class="hover:!text-primary-main flex items-center !border-r-2 hover:bg-primary-light duration-200 py-3 px-7 border-transparent"
        :to="'/dashboard/support'"
        :class="
          selectedItem === '/dashboard/support'
            ? 'border-primary-main !text-primary-main bg-primary-light'
            : ''
        "
      >
        <Icon :icon="'ant-design:exclamation-circle-outlined'" class="text-xl" />
        <span class="ml-3">Support</span>
      </router-link>
      <div
        @click="setSelectedItem('/dashboard/tutorials');openTutorials()"
        class="cursor-pointer hover:!text-primary-main flex items-center !border-r-2 hover:bg-primary-light duration-200 py-3 px-7 border-transparent"
        :class="
          selectedItem === '/dashboard/tutorials'
            ? 'border-primary-main !text-primary-main bg-primary-light'
            : ''
        "
      >
        <Icon :icon="'ant-design:play-square-outlined'" class="text-xl" />
        <span class="ml-3">WriteWise Tutorials</span>
      </div>
      <router-link
        @click="setSelectedItem('/dashboard/products')"
        class="hover:!text-primary-main flex items-center !border-r-2 hover:bg-primary-light duration-200 py-3 px-7 border-transparent"
        :to="'/dashboard/products'"
        :class="
          selectedItem === '/dashboard/products'
            ? 'border-primary-main !text-primary-main bg-primary-light'
            : ''
        "
      >
        <Icon :icon="'ant-design:shop-outlined'" class="text-xl" />
        <span class="ml-3">WriteWise Products</span>
      </router-link>

      <TlPopConfirm
        :title="'Are you sure you want to logout?'"
        :okText="'Yes, Logout'"
        :cancelText="'No'"
        :placement="'rightBottom'"
        @confirm="logout"
      >
        <div
          @click="setSelectedItem('/dashboard/logout')"
          class="cursor-pointer hover:!text-red-500 flex items-center hover:bg-red-200 duration-200 py-3 px-7"
          :class="selectedItem === '/dashboard/logout' ? 'border-red-500 !text-red-500 bg-red-200' : ''"
        >
          <Icon :icon="'ant-design:poweroff-outlined'" class="text-xl" />
          <span class="ml-3">Log Out</span>
        </div>
      </TlPopConfirm>
    </div>
    <Tutorials v-model="isTutorials" />
    <Referral v-model="isReferral" />
    <!-- <Affiliation /> -->
  </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';
import { dashboardSideNavLinks } from '@/utils/dashboardLinks';
import TlPopConfirm from '@/components/global/TlPopConfirm.vue';
import { logout } from '@/actions/auth';
import { usePayloadStore } from '@/stores/payload';
import { Vue, Options } from 'vue-class-component';
import router from '../../router/index';
import Tutorials from '@/components/global/Tutorials.vue';
import Referral from '@/components/global/Referral.vue';
import Affiliation from '@/components/global/Affiliation.vue';
@Options({
  components: {
    Icon,
    TlPopConfirm,
    Tutorials,
    Affiliation,
    Referral
  }
})
export default class SideNav extends Vue {
  created () {
    if (localStorage.getItem('viewedTutorial') == '0'){
      this.isTutorials = true;
      localStorage.setItem('viewedTutorial', '1')
    }
  }
  public dashboardSideNavLinks: any = dashboardSideNavLinks;

  public loadingResponse: boolean = false;

  public selectedItem: string = window?.location?.pathname || '/dashboard/documents';

  private payloadStore = usePayloadStore();

  public logout = () => {
    this.payloadStore.change({ loadingResponse: true });
    logout()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((res: any) => {
        this.payloadStore.change({ loadingResponse: false });
        this.payloadStore.clear();
        window.location.href = '/accounts/login/';
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((err: any) => {
        this.payloadStore.change({ loadingResponse: false });
        this.payloadStore.clear();
        window.location.href = '/accounts/login/';
      });
  };

  public setSelectedItem(item: string) {
    this.selectedItem = item;
  }

  public isTutorials = false;
  public openTutorials() {
    this.isTutorials = true;
  }

  public isReferral = false;
  public openReferral() {
    this.isReferral = true;
  }

  public newDocument = () => {
    this.payloadStore.change({ newDocument: true });
    this.setSelectedItem('/dashboard/documents')
    router.push({ path: '/dashboard/documents' })
  };

  public openUrl(url: string) {
    (window.open(url, '_blank') as any).focus();
  }
}
</script>
<style>
/* apply styles to the pop confirm container */
.ant-popover-inner {
  border-radius: 15px;
}
</style>
